// Script pour gérer les interactions du menu vertical

document.addEventListener('DOMContentLoaded', function() {
  // Gestion des sous-menus déroulants
  const dropdownItems = document.querySelectorAll('.category-menu-item.has-dropdown');
  
  dropdownItems.forEach(item => {
    const link = item.querySelector('.category-menu-link');
    
    link.addEventListener('click', function(e) {
      // Prévenir la navigation uniquement si on clique sur l'élément parent
      if (item.classList.contains('has-dropdown') && e.currentTarget === link) {
        e.preventDefault();
        
        // Toggle la classe active
        item.classList.toggle('active');
        
        // Fermer les autres menus déroulants
        dropdownItems.forEach(otherItem => {
          if (otherItem !== item && otherItem.classList.contains('active')) {
            otherItem.classList.remove('active');
          }
        });
      }
    });
  });
  
  // Activer automatiquement le sous-menu correspondant à la page active
  const currentUrl = window.location.pathname;
  const menuLinks = document.querySelectorAll('.category-menu-link, .category-submenu-link');
  
  menuLinks.forEach(link => {
    const linkUrl = new URL(link.href).pathname;
    
    if (currentUrl === linkUrl) {
      link.closest('.category-menu-item').classList.add('active');
      
      // Si c'est un sous-menu, ouvrir aussi le parent
      const parentItem = link.closest('.category-submenu')?.closest('.category-menu-item');
      if (parentItem) {
        parentItem.classList.add('active');
      }
    }
  });
});